export default __webpack_public_path__ + "static/media/img-0725-estonia-premium-face.6f0626f1.png";